import React, { useState, useEffect, useRef } from "react";
import { isEmpty, isNull } from "lodash";
import styled from "styled-components";
import { makeStyles, styled as materialStyle } from "@material-ui/core/styles";
import { Dialog, Typography, Grid, TextareaAutosize } from "@material-ui/core";
import DialogContent from "@material-ui/core/DialogContent";
import { useDispatch, useSelector } from "react-redux";
import {
  setTemplateIdToPreview,
  setTemplateToPreview,
  showAlert,
} from "../../../../actions/radminUploads";
import { ReactComponent as ArrowDropDownIcon } from "../../../../assets/chevron_down.svg";
import { ReactComponent as ArrowDropUpIcon } from "../../../../assets/chevron_up.svg";
import { ReactComponent as CloseIcon } from "../../../../assets/cancel-outline.svg";
import Flex from "../../../../components/_styles/Flex";
import Editor from "../Editor";
import { useLocation } from "react-router";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  datePicker: {
    paddingLeft: 36,
  },
  dialogContent: {
    minWidth: 1000,
    maxWidth: 1000,
    maxHeight: 600,
    minHeight: 188,
  },
  leftTabHead: {
    paddingBottom: 10,
  },
  tabLabel: {
    cursor: "pointer",
    color: "#9FA2B4",
    textAlign: "center",
  },
  rightTabHead: {
    textAlign: "right",
    paddingBottom: 10,
  },
  tabBorderBottom: {
    borderBottom: "3px solid #4dabf5",
  },
  formControlDropdownMessage: {
    width: "95%",
  },
  formControlDropdownTemplate: {
    width: "95%",
    marginLeft: "5%",
  },
  selectInput: {
    padding: 10,
    fontSize: 16,
    "& .MuiOutlinedInput-input": {
      padding: 0,
    },
  },
  chooseMessageTypeSec: {
    display: "flex",
  },
  labelColor: {
    color: "#0C2945",
  },
  textField: {
    "& .MuiOutlinedInput-input": {
      fontSize: 14,
      padding: "10.5px 14px",
    },
  },
  centerSec: {
    height: "auto",
    maxHeight: 410,
    margin: "0 auto",
  },
  smsFromSec: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
  },
  smsToSec: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
  },
}));

export const SmsContent = materialStyle(Typography)({
  color: "#000000",
  fontSize: 14,
  fontWeight: 400,
  padding: "0",
  fontFamily: "Roboto Condensed",
});

const AddButton = styled.button`
  color: white;
  background-color: #00aeef;
  border: none;
  border-radius: 4px;
  padding: 0 12px;
  font-size: 15px;
  font-weight: 600;
  height: 38px;
  span {
    display: inline-block;
    transition: transform 0.3s ease-in-out;
  }

  &:hover {
    background-color: #06739d;
    border: none;
  }

  &:hover span {
    transform: scale(1.1);
  }
`;

const InputField = styled.input`
  height: 38px;
  width: 255px;
  font-size: 16px;
  border: 1px solid #d2d3d7;
  border-radius: 4px;
  padding-left: 12px;
  padding-right: 12px;
`;

export const DatePickerButton = styled(Flex)`
  padding: 13px;
  align-items: center;
  background: #00aeef;
  height: 38px;
  border: none;
  width: 210px;
  border-radius: 4px;
  justify-content: center;
  &:hover {
    cursor: pointer;
    background-color: ${(props) => props.hoverBg || "#0088CC"};
    border: none;
  }
`;

export const DateContainer = styled(Flex)`
  font-size: 14px;
  color: #ffffff;
  font-weight: 600;
  span {
    transition: transform 0.3s ease-in-out;
  }

  &:hover span {
    font-weight: bold;
    transform: scale(1.1);
  }
`;

export const NormalText = materialStyle(Typography)({
  fontSize: 14,
  color: "#3F4857",
  fontFamily: "Roboto Condensed",
  display: "inline",
});

const PersionalizedText = materialStyle(Typography)({
  color: "black",
  fontSize: 16,
  fontWeight: 400,
  padding: "8px 0",
  width: "100%",
  paddingLeft: 10,
});

export const PersonalizedInnerContainer = materialStyle(Grid)({
  cursor: "pointer",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  height: 38,
});

export const ParagraphContainer = materialStyle(Grid)({
  padding: "5px 10px",
  cursor: "auto",
});
export const SmsInfoContainer = materialStyle(Grid)({
  padding: "0px 10px",
  display: "flex",
});

const BottomContainer = materialStyle(Grid)({
  margin: "0 auto",
});
export const DateLabel = materialStyle(Typography)({
  color: "#AAAEBD",
  fontSize: 12,
});

export const PersionalizedTextContainer = materialStyle(Grid)({
  border: "1px solid #CBCCCF",
  borderRadius: "4px",
});
const PersonalizedFieldSection = materialStyle(Grid)({
  display: "flex",
  alignItems: "center",
  width: "100%",
  gap: "21px",
  justifyContent: "flex-end",
  marginRight: "21px",
});

const InsertPersonalizedSection = materialStyle(Grid)({
  backgroundColor: "#F5F5F5",
  height: "200px",
  overflowY: "auto",
  padding: "10px 0px",
});
const PersonalizedRow = materialStyle(Grid)({
  display: "flex",
  justifyContent: "space-between",
  marginBottom: "8px",
});
const PeronalizedText = materialStyle(Typography)({
  fontSize: 14,
  fontWeight: 400,
  margin: 0,
  marginLeft: 10,
  color: "#8F8F8F",
});

const PreviewButtonContainer = materialStyle(Grid)({
  display: "flex",
  justifyContent: "flex-end",
  marginBottom: "28px",
  color: "#00AEEF",
  p: {
    transition: "transform 0.3s ease-in-out",
  },

  "&:hover p": {
    color: "#06739D",
    fontWeight: "bold",
    transform: "scale(1.1)",
  },
});

export const CreateTemplateContainer = materialStyle(Grid)({
  maxHeight: "290px",
});

const CreateTemplate = ({
  activeTab,
  isClickedPersionalized,
  personalizedClickHandler,
  defaultValue,
  handleChange,
  addDefaultHandler,
}) => {
  const classes = useStyles();

  return (
    <>
      {activeTab === "fax" ? (
        <CreateTemplateContainer>
          <PersionalizedTextContainer>
            <PersonalizedInnerContainer
              isClicked={isClickedPersionalized}
              onClick={personalizedClickHandler}
            >
              <PeronalizedText>Select...</PeronalizedText>
              {isClickedPersionalized ? (
                <ArrowDropUpIcon
                  style={{ cursor: "pointer", marginRight: 10 }}
                />
              ) : (
                <ArrowDropDownIcon
                  style={{ cursor: "pointer", marginRight: 10 }}
                />
              )}
            </PersonalizedInnerContainer>
          </PersionalizedTextContainer>

          {isClickedPersionalized ? (
            <InsertPersonalizedSection>
              <PersonalizedRow noBorder>
                <BottomContainer>
                  <PersionalizedText>{"{{patient_mrn}}"}</PersionalizedText>
                </BottomContainer>
                <PersonalizedFieldSection>
                  <InputField
                    type="text"
                    name="patientMRN"
                    value={defaultValue.patientMRN}
                    onChange={(e) => handleChange(e)}
                    placeholder="Please add a default"
                  />
                  <AddButton
                    onClick={() =>
                      isEmpty(defaultValue.patientMRN)
                        ? alert("Value required!")
                        : addDefaultHandler("row1")
                    }
                  >
                    <span>Add</span>
                  </AddButton>
                </PersonalizedFieldSection>
              </PersonalizedRow>
              <PersonalizedRow>
                <BottomContainer>
                  <PersionalizedText>
                    {"{{recommendation_anatomy}}"}
                  </PersionalizedText>
                </BottomContainer>
                <PersonalizedFieldSection>
                  <InputField
                    type="text"
                    name="recommendationAnatomy"
                    value={defaultValue.recommendationAnatomy}
                    onChange={(e) => handleChange(e)}
                    placeholder="Please add a default"
                  />
                  <AddButton
                    onClick={() =>
                      isEmpty(defaultValue.recommendationAnatomy)
                        ? alert("Value required!")
                        : addDefaultHandler("row2")
                    }
                  >
                    <span>Add</span>
                  </AddButton>
                </PersonalizedFieldSection>
              </PersonalizedRow>
              <PersonalizedRow>
                <BottomContainer>
                  <PersionalizedText>
                    {"{{recommendation_modality}}"}
                  </PersionalizedText>
                </BottomContainer>
                <PersonalizedFieldSection>
                  <InputField
                    type="text"
                    name="recommendationModality"
                    value={defaultValue.recommendationModality}
                    onChange={(e) => handleChange(e)}
                    placeholder="Please add a default"
                  />
                  <AddButton
                    onClick={() =>
                      isEmpty(defaultValue.recommendationModality)
                        ? alert("Value required!")
                        : addDefaultHandler("row3")
                    }
                  >
                    <span>Add</span>
                  </AddButton>
                </PersonalizedFieldSection>
              </PersonalizedRow>

              <PersonalizedRow>
                <BottomContainer>
                  <PersionalizedText>
                    {"{{recommendation_range_end}}"}
                  </PersionalizedText>
                </BottomContainer>
                <PersonalizedFieldSection>
                  <InputField
                    type="text"
                    name="recommendationRangeEnd"
                    value={defaultValue.recommendationRangeEnd}
                    onChange={(e) => handleChange(e)}
                    placeholder="Please add a default"
                  />
                  <AddButton
                    onClick={() =>
                      isEmpty(defaultValue.recommendationRangeEnd)
                        ? alert("Value required!")
                        : addDefaultHandler("row4")
                    }
                  >
                    <span>Add</span>
                  </AddButton>
                </PersonalizedFieldSection>
              </PersonalizedRow>

              <PersonalizedRow>
                <BottomContainer>
                  <PersionalizedText>
                    {"{{recommendation_range_start}}"}
                  </PersionalizedText>
                </BottomContainer>
                <PersonalizedFieldSection>
                  <InputField
                    type="text"
                    name="recommendationRangeStart"
                    value={defaultValue.recommendationRangeStart}
                    onChange={(e) => handleChange(e)}
                    placeholder="Please add a default"
                  />
                  <AddButton
                    onClick={() =>
                      isEmpty(defaultValue.recommendationRangeStart)
                        ? alert("Value required!")
                        : addDefaultHandler("row5")
                    }
                  >
                    <span>Add</span>
                  </AddButton>
                </PersonalizedFieldSection>
              </PersonalizedRow>
              <PersonalizedRow>
                <BottomContainer>
                  <PersionalizedText>
                    {"{{referring_physician_first_name}}"}
                  </PersionalizedText>
                </BottomContainer>
                <PersonalizedFieldSection>
                  <InputField
                    type="text"
                    name="referringPhysicianFirstName"
                    value={defaultValue.referringPhysicianFirstName}
                    onChange={(e) => handleChange(e)}
                    placeholder="Please add a default"
                  />
                  <AddButton
                    onClick={() =>
                      isEmpty(defaultValue.referringPhysicianFirstName)
                        ? alert("Value required!")
                        : addDefaultHandler("row6")
                    }
                  >
                    <span>Add</span>
                  </AddButton>
                </PersonalizedFieldSection>
              </PersonalizedRow>
              <PersonalizedRow>
                <BottomContainer>
                  <PersionalizedText>
                    {"{{referring_physician_last_name}}"}
                  </PersionalizedText>
                </BottomContainer>
                <PersonalizedFieldSection>
                  <InputField
                    type="text"
                    name="referringPhysicianLastName"
                    value={defaultValue.referringPhysicianLastName}
                    onChange={(e) => handleChange(e)}
                    placeholder="Please add a default"
                  />
                  <AddButton
                    onClick={() =>
                      isEmpty(defaultValue.referringPhysicianLastName)
                        ? alert("Value required!")
                        : addDefaultHandler("row7")
                    }
                  >
                    <span>Add</span>
                  </AddButton>
                </PersonalizedFieldSection>
              </PersonalizedRow>
              <PersonalizedRow>
                <BottomContainer>
                  <PersionalizedText>
                    {"{{patient_first_name}}"}
                  </PersionalizedText>
                </BottomContainer>
                <PersonalizedFieldSection>
                  <InputField
                    type="text"
                    name="patientFirstName"
                    value={defaultValue.patientFirstName}
                    onChange={(e) => handleChange(e)}
                    placeholder="Please add a default"
                  />
                  <AddButton
                    onClick={() =>
                      isEmpty(defaultValue.patientFirstName)
                        ? alert("Value required!")
                        : addDefaultHandler("row8")
                    }
                  >
                    <span>Add</span>
                  </AddButton>
                </PersonalizedFieldSection>
              </PersonalizedRow>
              <PersonalizedRow>
                <BottomContainer>
                  <PersionalizedText>
                    {"{{patient_last_name}}"}
                  </PersionalizedText>
                </BottomContainer>
                <PersonalizedFieldSection>
                  <InputField
                    type="text"
                    name="patientLastName"
                    value={defaultValue.patientLastName}
                    onChange={(e) => handleChange(e)}
                    placeholder="Please add a default"
                  />
                  <AddButton
                    onClick={() =>
                      isEmpty(defaultValue.patientLastName)
                        ? alert("Value required!")
                        : addDefaultHandler("row9")
                    }
                  >
                    <span>Add</span>
                  </AddButton>
                </PersonalizedFieldSection>
              </PersonalizedRow>
              <PersonalizedRow>
                <BottomContainer>
                  <PersionalizedText>
                    {"{{initial_study_modality}}"}
                  </PersionalizedText>
                </BottomContainer>
                <PersonalizedFieldSection>
                  <InputField
                    type="text"
                    name="initialStudyModal"
                    value={defaultValue.initialStudyModal}
                    onChange={(e) => handleChange(e)}
                    placeholder="Please add a default"
                  />
                  <AddButton
                    onClick={() =>
                      isEmpty(defaultValue.initialStudyModal)
                        ? alert("Value required!")
                        : addDefaultHandler("row10")
                    }
                  >
                    <span>Add</span>
                  </AddButton>
                </PersonalizedFieldSection>
              </PersonalizedRow>
              <PersonalizedRow>
                <BottomContainer>
                  <PersionalizedText>
                    {"{{initial_exam_location_address}}"}
                  </PersionalizedText>
                </BottomContainer>
                <PersonalizedFieldSection>
                  <InputField
                    type="text"
                    name="initialLocationAddress"
                    value={defaultValue.initialLocationAddress}
                    onChange={(e) => handleChange(e)}
                    placeholder="Please add a default"
                  />
                  <AddButton
                    onClick={() =>
                      isEmpty(defaultValue.initialLocationAddress)
                        ? alert("Value required!")
                        : addDefaultHandler("row11")
                    }
                  >
                    <span>Add</span>
                  </AddButton>
                </PersonalizedFieldSection>
              </PersonalizedRow>
              <PersonalizedRow>
                <BottomContainer>
                  <PersionalizedText>{"{{exam_date}}"}</PersionalizedText>
                </BottomContainer>
                <PersonalizedFieldSection>
                  <InputField
                    type="text"
                    name="examDate"
                    value={defaultValue.examDate}
                    onChange={(e) => handleChange(e)}
                    placeholder="Please add a default"
                  />
                  <AddButton
                    onClick={() =>
                      isEmpty(defaultValue.examDate)
                        ? alert("Value required!")
                        : addDefaultHandler("row12")
                    }
                  >
                    <span>Add</span>
                  </AddButton>
                </PersonalizedFieldSection>
              </PersonalizedRow>
            </InsertPersonalizedSection>
          ) : null}
        </CreateTemplateContainer>
      ) : (
        <CreateTemplateContainer>
          <PersionalizedTextContainer>
            <PersonalizedInnerContainer
              isClicked={isClickedPersionalized}
              onClick={personalizedClickHandler}
            >
              <PeronalizedText>Select...</PeronalizedText>
              {isClickedPersionalized ? (
                <ArrowDropUpIcon
                  style={{ cursor: "pointer", marginRight: 10 }}
                />
              ) : (
                <ArrowDropDownIcon
                  style={{ cursor: "pointer", marginRight: 10 }}
                />
              )}
            </PersonalizedInnerContainer>
          </PersionalizedTextContainer>
          {isClickedPersionalized ? (
            <InsertPersonalizedSection>
              <PersonalizedRow noBorder>
                <BottomContainer>
                  <PersionalizedText>{"{{first_name}}"}</PersionalizedText>
                </BottomContainer>
                <PersonalizedFieldSection>
                  <InputField
                    type="text"
                    name="patientNameDefaultValue"
                    value={defaultValue.patientNameDefaultValue}
                    onChange={(e) => handleChange(e)}
                    placeholder="Please add a default"
                  />
                  <AddButton
                    onClick={() =>
                      isEmpty(defaultValue.patientNameDefaultValue)
                        ? alert("Value required!")
                        : addDefaultHandler("row1")
                    }
                  >
                    <span>Add</span>
                  </AddButton>
                </PersonalizedFieldSection>
              </PersonalizedRow>
              <PersonalizedRow>
                <BottomContainer>
                  <PersionalizedText>
                    {"{{referring_physician_first_name}}"}
                  </PersionalizedText>
                </BottomContainer>
                <PersonalizedFieldSection>
                  <InputField
                    type="text"
                    name="referringPhysicianDefaultValue"
                    value={defaultValue.referringPhysicianDefaultValue}
                    onChange={(e) => handleChange(e)}
                    placeholder="Please add a default"
                  />
                  <AddButton
                    onClick={() =>
                      isEmpty(defaultValue.referringPhysicianDefaultValue)
                        ? alert("Value required!")
                        : addDefaultHandler("row2")
                    }
                  >
                    <span>Add</span>
                  </AddButton>
                </PersonalizedFieldSection>
              </PersonalizedRow>
              <PersonalizedRow>
                <BottomContainer>
                  <PersionalizedText>
                    {"{{referring_physician_phone_number}}"}
                  </PersionalizedText>
                </BottomContainer>
                <PersonalizedFieldSection>
                  <InputField
                    type="text"
                    name="referringPhysicianDefaultNumber"
                    value={defaultValue.referringPhysicianDefaultNumber}
                    onChange={(e) => handleChange(e)}
                    placeholder="Please add a default"
                  />
                  <AddButton
                    onClick={() =>
                      isEmpty(defaultValue.referringPhysicianDefaultNumber)
                        ? alert("Value required!")
                        : addDefaultHandler("row3")
                    }
                  >
                    <span>Add</span>
                  </AddButton>
                </PersonalizedFieldSection>
              </PersonalizedRow>

              <PersonalizedRow>
                <BottomContainer>
                  <PersionalizedText>
                    {"{{primary_care_physician_first_name}}"}
                  </PersionalizedText>
                </BottomContainer>
                <PersonalizedFieldSection>
                  <InputField
                    type="text"
                    name="pcpDefaultName"
                    value={defaultValue.pcpDefaultName}
                    onChange={(e) => handleChange(e)}
                    placeholder="Please add a default"
                  />
                  <AddButton
                    onClick={() =>
                      isEmpty(defaultValue.pcpDefaultName)
                        ? alert("Value required!")
                        : addDefaultHandler("row4")
                    }
                  >
                    <span>Add</span>
                  </AddButton>
                </PersonalizedFieldSection>
              </PersonalizedRow>

              <PersonalizedRow>
                <BottomContainer>
                  <PersionalizedText>
                    {"{{primary_care_physician_phone_number}}"}
                  </PersionalizedText>
                </BottomContainer>
                <PersonalizedFieldSection>
                  <InputField
                    type="text"
                    name="pcpDefaultNumber"
                    value={defaultValue.pcpDefaultNumber}
                    onChange={(e) => handleChange(e)}
                    placeholder="Please add a default"
                  />
                  <AddButton
                    onClick={() =>
                      isEmpty(defaultValue.pcpDefaultNumber)
                        ? alert("Value required!")
                        : addDefaultHandler("row5")
                    }
                  >
                    <span>Add</span>
                  </AddButton>
                </PersonalizedFieldSection>
              </PersonalizedRow>
              <PersonalizedRow>
                <BottomContainer>
                  <PersionalizedText>{"{{provider_name}}"}</PersionalizedText>
                </BottomContainer>
                <PersonalizedFieldSection>
                  <InputField
                    type="text"
                    name="providerDefaultName"
                    value={defaultValue.providerDefaultName}
                    onChange={(e) => handleChange(e)}
                    placeholder="Please add a default"
                  />
                  <AddButton
                    onClick={() =>
                      isEmpty(defaultValue.providerDefaultName)
                        ? alert("Value required!")
                        : addDefaultHandler("row6")
                    }
                  >
                    <span>Add</span>
                  </AddButton>
                </PersonalizedFieldSection>
              </PersonalizedRow>
            </InsertPersonalizedSection>
          ) : null}
        </CreateTemplateContainer>
      )}
    </>
  );
};

function TemplateCreationDialog({
  setOpenTemplateDialog,
  onSaveTemplates,
  selectedTemplate,
  openTemplateDialog,
  defaultValue,
  setDefaultValue,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();
  const quillRef = useRef();
  const textareaRef = useRef(null);
  const permissionGroup = "Templates";
  const permissionName = "templates";
  const queryParams = new URLSearchParams(location.search);
  const actionState = queryParams.get("type");
  const activeTab = queryParams.get("tab");

  const permission = useSelector((state) => state.auth.user.permission_level);
  const rolePermissions = useSelector((state) => state.auth.user.permissions);
  const updatePermission = rolePermissions
    ?.find((itm) => itm.name === permissionGroup)
    ?.permissions.find(
      (itm) => itm.codename === `change_${permissionName}`
    )?.is_authorized;
  const [templateContent, setTemplateContent] = useState(
    selectedTemplate?.message_content || ""
  );
  const [isSaveTemplateClicked, setIsSaveTemplateClicked] = useState(false);
  const [cursorPosition, setCursorPosition] = useState(null);
  const [isClickedPersionalized, setIsClickedPersionalized] = useState(false);

  useEffect(() => {
    if (!isNull(selectedTemplate)) {
      setTemplateContent(selectedTemplate.message_content);
    }
  }, [selectedTemplate]);

  const checkforTemplatedContent = (value, key) => {
    let newValue;
    let content;

    if (activeTab === "fax") {
      const quill = quillRef.current.getEditor();
      newValue = `{{${key} | default("${value}")}}`;
      const regex = new RegExp(`{{${key} \\| default\\(.*?\\)}}`, "g");

      content = quill.root.innerHTML;

      if (regex.test(content)) {
        content = content.replace(regex, newValue);
        setTemplateContent(content);
        setIsClickedPersionalized(false);
        setCursorPosition(content.length);
        return;
      } else if (cursorPosition !== null) {
        quill.insertText(cursorPosition, newValue, "user");
        const newCursorPosition = cursorPosition + newValue.length;
        quill.setSelection(newCursorPosition, 0);
        setCursorPosition(newCursorPosition);
      } else {
        const length = quill.getLength();
        quill.insertText(length, newValue, "user");
        quill.setSelection(length + newValue.length, 0);
      }
      const updatedContent = quill.root.innerHTML;
      setTemplateContent(updatedContent);
    }
    if (activeTab === "sms") {
      content = templateContent;
      const newValue = `{{${key} | default("${value}")}}`;

      const regex = new RegExp(`{{${key} \\| default\\(.*?\\)}}`, "g");
      if (regex.test(content)) {
        const updatedContent = content.replace(regex, newValue);
        setTemplateContent(updatedContent);
        return;
      }

      const textarea = textareaRef.current;
      const cursorPosition = textarea.selectionStart;

      const beforeCursor = content.substring(0, cursorPosition);
      const afterCursor = content.substring(cursorPosition);
      const updatedContent = beforeCursor + newValue + afterCursor;

      setTemplateContent(updatedContent);
    }
    setIsClickedPersionalized(false);
  };

  const updateTemplateHandler = async (isEditable) => {
    setIsSaveTemplateClicked(true);
    if (isSaveTemplateClicked) {
      return;
    }
    window.analytics.track("Edit-Template-Button-Click");
    if ((permission && updatePermission) || !permission) {
      if (isEditable) {
        await onSaveTemplates(templateContent);
      } else {
        if (activeTab === "sms" && actionState === "manual") {
          await onSaveTemplates(templateContent);
        } else {
          dispatch(
            showAlert(
              "danger",
              "Error",
              `No changes can be made to this template`
            )
          );
        }
      }
    } else {
      dispatch(
        showAlert(
          "danger",
          "Error",
          `You don't have permission to update template`
        )
      );
    }
    setIsSaveTemplateClicked(false);
  };

  const onCloseDialogHandler = () => {
    setOpenTemplateDialog(false);
    setTemplateContent("");
    setDefaultValue({
      ...defaultValue,
      patientNameDefaultValue: "",
      referringPhysicianDefaultValue: "",
      referringPhysicianDefaultNumber: "",
      pcpDefaultName: "",
      pcpDefaultNumber: "",
      providerDefaultName: "",
    });
    setDefaultValue({
      ...defaultValue,
      patientNameDefaultValue: "",
      referringPhysicianDefaultValue: "",
      referringPhysicianDefaultNumber: "",
      pcpDefaultName: "",
      pcpDefaultNumber: "",
      providerDefaultName: "",
    });
    dispatch(setTemplateIdToPreview(null));
    dispatch(setTemplateToPreview(null));
  };

  function extractStartingNumber(phoneStr) {
    const matches = phoneStr.match(/\(?\+?[0-9]+[\)\s\-0-9]*/g);

    return matches ? matches[0].trim() : "";
  }

  const addDefaultHandler = (from) => {
    if (activeTab === "fax") {
      if (from === "row1") {
        checkforTemplatedContent(defaultValue.patientMRN, "patient_mrn");
      } else if (from === "row2") {
        checkforTemplatedContent(
          defaultValue.recommendationAnatomy,
          "recommendation_anatomy"
        );
      } else if (from === "row3") {
        checkforTemplatedContent(
          defaultValue.recommendationModality,
          "recommendation_modality"
        );
      } else if (from === "row4") {
        checkforTemplatedContent(
          defaultValue.recommendationRangeEnd,
          "recommendation_range_end"
        );
      } else if (from === "row5") {
        checkforTemplatedContent(
          defaultValue.recommendationRangeStart,
          "recommendation_range_start"
        );
      } else if (from === "row6") {
        checkforTemplatedContent(
          defaultValue.referringPhysicianFirstName,
          "referring_physician_first_name"
        );
      } else if (from === "row7") {
        checkforTemplatedContent(
          defaultValue.referringPhysicianLastName,
          "referring_physician_last_name"
        );
      } else if (from === "row8") {
        checkforTemplatedContent(
          defaultValue.patientFirstName,
          "patient_first_name"
        );
      } else if (from === "row9") {
        checkforTemplatedContent(
          defaultValue.patientLastName,
          "patient_last_name"
        );
      } else if (from === "row10") {
        checkforTemplatedContent(
          defaultValue.initialStudyModal,
          "initial_study_modality"
        );
      } else if (from === "row11") {
        checkforTemplatedContent(
          defaultValue.initialLocationAddress,
          "initial_exam_location_address"
        );
      } else if (from === "row12") {
        checkforTemplatedContent(defaultValue.examDate, "exam_date");
      }
    } else if (activeTab === "sms") {
      if (from === "row1") {
        checkforTemplatedContent(
          defaultValue.patientNameDefaultValue,
          "first_name"
        );
      } else if (from === "row2") {
        checkforTemplatedContent(
          defaultValue.referringPhysicianDefaultValue,
          "referring_physician_first_name"
        );
      } else if (from === "row3") {
        checkforTemplatedContent(
          defaultValue.referringPhysicianDefaultNumber,
          "referring_physician_phone_number"
        );
      } else if (from === "row4") {
        checkforTemplatedContent(
          defaultValue.pcpDefaultName,
          "primary_care_physician_first_name"
        );
      } else if (from === "row5") {
        checkforTemplatedContent(
          defaultValue.pcpDefaultNumber,
          "primary_care_physician_phone_number"
        );
      } else {
        checkforTemplatedContent(
          defaultValue.providerDefaultName,
          "provider_name"
        );
      }
    }
  };

  const personalizedClickHandler = () => {
    setIsClickedPersionalized(!isClickedPersionalized);
  };
  const handleChange = (e) => {
    let { name, value } = e.target;
    setDefaultValue({ ...defaultValue, [name]: value });
  };

  const cursor = () => {
    if (
      activeTab === "sms" &&
      actionState === "manual" &&
      !isSaveTemplateClicked
    ) {
      return "pointer";
    }
    if (selectedTemplate?.editable || !isSaveTemplateClicked) {
      return "pointer";
    }

    return "not-allowed";
  };

  const handleCursorChange = () => {
    const quill = quillRef.current.getEditor();
    const selection = quill.getSelection();
    if (selection) {
      setCursorPosition(selection.index);
    }
  };

  const isFax = activeTab === "fax";
  const isManualSms = activeTab === "sms" && actionState === "manual";

  return (
    <div>
      <Dialog
        open={openTemplateDialog}
        aria-labelledby="form-dialog-title"
        maxWidth="lg"
        style={{
          backdropFilter: "blur(5px)",
        }}
        onClose={() => onCloseDialogHandler()}
      >
        <DialogContent
          style={{ width: "1000px", height: "initial", paddingTop: "30px" }}
          className={classes.dialogContent}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h2
              style={{
                color: "#0C2945",
                fontSize: "28px",
                fontWeight: 700,
                fontFamily: "Roboto Condensed",
                marginBottom: 0,
              }}
            >
              {selectedTemplate && selectedTemplate?.title}
            </h2>
            <CloseIcon
              style={{ cursor: "pointer" }}
              onClick={() => setOpenTemplateDialog(false)}
            />
          </div>

          <>
            {(isFax || isManualSms) && (
              <div>
                <h4
                  style={{
                    fontFamily: "Roboto Condensed",
                    fontSize: "14px",
                    fontWeight: 700,
                    color: "#6D6E6E",
                    marginTop: "30px",
                  }}
                >
                  PERSONALIZED CONTENT
                </h4>
                <CreateTemplate
                  activeTab={activeTab}
                  isClickedPersionalized={isClickedPersionalized}
                  personalizedClickHandler={personalizedClickHandler}
                  defaultValue={defaultValue}
                  handleChange={handleChange}
                  addDefaultHandler={addDefaultHandler}
                />
              </div>
            )}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginTop: "30px",
                marginBottom: "8px",
              }}
            >
              <h4
                style={{
                  fontFamily: "Roboto Condensed",
                  fontSize: "14px",
                  fontWeight: 700,
                  color: "#6D6E6E",
                  marginBottom: "0px",
                  textTransform: "uppercase",
                }}
              >
                {`${activeTab} CONTENT`}
              </h4>
              {selectedTemplate && activeTab !== "fax" && (
                <div style={{ display: "flex", gap: "37px" }}>
                  <SmsContent>
                    {(activeTab === "sms" && actionState === "automatic") ||
                    activeTab === "email"
                      ? "From:"
                      : null}
                    {activeTab === "sms" && actionState === "automatic"
                      ? extractStartingNumber(selectedTemplate?.from)
                      : selectedTemplate?.from}
                  </SmsContent>
                </div>
              )}
            </div>

            {activeTab === "sms" ? (
              <TextareaAutosize
                maxRows={8}
                aria-label="maximum height"
                value={templateContent}
                disabled={
                  actionState !== "manual" ? !selectedTemplate?.editable : false
                }
                ref={textareaRef}
                onChange={(e) => setTemplateContent(e.target.value)}
                style={{
                  width: "100%",
                  fontSize: 14,
                  color: "#000000",
                  fontFamily: "Open Sans",
                  display: "inline",
                  lineHeight: 2,
                  height: "150px",
                  padding: "9px 12px",
                  border: "1px solid #D2D3D7",
                  borderRadius: 4,
                  overflow: "auto",
                }}
                placeholder={"This is placeholder text - Change me!"}
              ></TextareaAutosize>
            ) : (
              <Editor
                templateContent={templateContent}
                setTemplateContent={setTemplateContent}
                placeholder={"This is placeholder text - Change me!"}
                quillRef={quillRef}
                handleCursorChange={
                  activeTab === "fax" ? handleCursorChange : undefined
                }
                isReadOnly={selectedTemplate?.editable ? false : true}
              />
            )}
          </>
          <BottomContainer>
            <PreviewButtonContainer spanText={"#06739D"}>
              <p
                onClick={() => {
                  if (activeTab === "sms" && actionState === "manual") {
                    updateTemplateHandler(selectedTemplate?.editable);
                  } else {
                    selectedTemplate?.editable &&
                      updateTemplateHandler(selectedTemplate?.editable);
                  }
                }}
                style={{
                  fontWeight: 600,
                  fontSize: "14px",
                  cursor: cursor(),
                  marginTop: "5px",
                }}
              >
                Save Changes to Template
              </p>
            </PreviewButtonContainer>
          </BottomContainer>
        </DialogContent>
      </Dialog>
    </div>
  );
}
export default React.memo(TemplateCreationDialog);
